import React from 'react'
import { Config } from '../types/types'
import settings from "../config/settings.json";
const domain = window.location.hostname;


export const config = settings.websites.find( website => domain.indexOf(website.url) >= 0 || website.url === '') || settings.websites[0];


const ConfigContext = React.createContext<Partial<Config>>(config,)
export const ConfigProvider = ConfigContext.Provider
export default ConfigContext
